<script>
  import t from '$lib/i18n.svelte.js';
  let {
    status = 500,
    message = 'unknown_error_occured'
  } = $props()
</script>

<div class="p-8 px py">
  <h1>{status}</h1>
  <h2>{t(message)}</h2>
</div>